import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import BrandBlogPage from './BrandBlogPage';

export default function BlogPage() {
  return (
    <>
      <Navbar />
      <BrandBlogPage
        publisher="未境原創"
        brandName="未境原創"
        englishName="VIJING"
        tagline="以愛情故事延伸不同情感與人生想像"
      />
      <Footer />
    </>
  );
}

